import axios from 'axios'

export default {
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
    identifyOrder (context, payload) {
      const orderNumber = payload
      let url = process.env.VUE_APP_URLAPI
      url += '/wp-json/wc/v3/orders/'
      url += orderNumber
      url += '?consumer_key=' + process.env.VUE_APP_CUSTOMER
      url += '&consumer_secret=' + process.env.VUE_APP_SECRET
      return new Promise((resolve, reject) => {
        axios.get(url)
          .then(response => {
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    identifyBooking (context, payload) {
      const bookingNumber = payload
      let url = process.env.VUE_APP_URLAPI
      url += '/wp-json/wc-bookings/v1/bookings/'
      url += bookingNumber
      url += '?consumer_key=' + process.env.VUE_APP_CUSTOMER
      url += '&consumer_secret=' + process.env.VUE_APP_SECRET
      return new Promise((resolve, reject) => {
        axios.get(url)
          .then(response => {
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    changeOrderStatus (context, payload) {
      const orderNumber = payload
      const data = {
        status: 'qrcodeused'
      }
      let url = process.env.VUE_APP_URLAPI
      url += '/wp-json/wc/v3/orders/'
      url += orderNumber
      url += '?consumer_key=' + process.env.VUE_APP_CUSTOMER
      url += '&consumer_secret=' + process.env.VUE_APP_SECRET
      return new Promise((resolve, reject) => {
        axios.put(url, data)
          .then(response => {
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    }
  }
}
